// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    display: block;
    width: 100%;
    height: 100%;
}

.kichat-root {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 280px;
    background: var(--background-color, #fff);
    color: inherit;
    overflow: hidden;
    font-family: inherit;
}

.kichat-root.has-drawer {
    flex-direction: row-reverse;
}

/* Drawer on the left side (opt-in via the TopicsLeft property) */
.kichat-root.has-drawer.drawer-left {
    flex-direction: row;
}

.kichat-main {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-width: 0;
    position: relative;
}

/* ---------- Drawer ---------- */
.kichat-drawer {
    flex: 0 0 auto;
    width: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border-left: 1px solid rgba(0, 0, 0, 0.08);
    background: rgba(0, 0, 0, 0.02);
    transition: width 0.2s ease;
}

.kichat-root.drawer-open .kichat-drawer {
    width: 260px;
}

:host-context(.isDarkTheme) .kichat-drawer {
    border-left-color: rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.03);
}

/* When the drawer sits on the left, the separating border moves to its right edge. */
.kichat-root.drawer-left .kichat-drawer {
    border-left: 0;
    border-right: 1px solid rgba(0, 0, 0, 0.08);
}

:host-context(.isDarkTheme) .kichat-root.drawer-left .kichat-drawer {
    border-right-color: rgba(255, 255, 255, 0.08);
}

.kichat-drawer-header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 8px 8px 12px;
    min-height: 44px;
}

.kichat-drawer-title {
    flex: 1 1 auto;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    opacity: 0.6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.kichat-drawer-toggle {
    flex: 0 0 auto;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: none;
    background: transparent;
    color: inherit;
    opacity: 0.7;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.kichat-drawer-toggle:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.06);
    opacity: 1;
}

:host-context(.isDarkTheme) .kichat-drawer-toggle:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
}

.kichat-drawer-toggle mat-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
}

.kichat-drawer-toggle-floating {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    background: var(--background-color, #fff);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.kichat-root.drawer-left .kichat-drawer-toggle-floating {
    right: auto;
    left: 8px;
}

:host-context(.isDarkTheme) .kichat-drawer-toggle-floating {
    background: rgba(255, 255, 255, 0.06);
}

/* Floating "Export as HTML" action (top-right of the chat pane). Shifts left to sit beside
   the floating drawer toggle when that toggle shares the top-right corner. */
.kichat-export-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: none;
    background: var(--background-color, #fff);
    color: inherit;
    opacity: 0.7;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.kichat-export-btn:hover {
    opacity: 1;
}

.kichat-export-btn.kichat-export-shifted {
    right: 48px;
}

:host-context(.isDarkTheme) .kichat-export-btn {
    background: rgba(255, 255, 255, 0.06);
}

.kichat-export-btn mat-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
}

.kichat-drawer-new {
    flex: 0 0 auto;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: none;
    background: transparent;
    color: inherit;
    opacity: 0.7;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.kichat-drawer-new:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.06);
    opacity: 1;
}

:host-context(.isDarkTheme) .kichat-drawer-new:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
}

.kichat-drawer-new:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.kichat-drawer-new mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
}

.kichat-drawer-body {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 4px 8px 12px;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.kichat-session {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.88rem;
    line-height: 1.3;
    color: inherit;
    background: transparent;
    border: none;
    text-align: left;
    width: 100%;
}

.kichat-session:hover {
    background: rgba(0, 0, 0, 0.05);
}

:host-context(.isDarkTheme) .kichat-session:hover {
    background: rgba(255, 255, 255, 0.06);
}

.kichat-session.active {
    background: rgba(25, 118, 210, 0.12);
}

:host-context(.isDarkTheme) .kichat-session.active {
    background: rgba(144, 202, 249, 0.18);
}

.kichat-session-icon {
    flex: 0 0 18px;
    font-size: 18px;
    width: 18px;
    height: 18px;
    opacity: 0.7;
}

.kichat-session-name {
    flex: 1 1 auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.kichat-session-delete {
    flex: 0 0 auto;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: none;
    background: transparent;
    color: inherit;
    opacity: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.kichat-session:hover .kichat-session-delete {
    opacity: 0.7;
}

.kichat-session-delete:hover {
    background: rgba(0, 0, 0, 0.08);
    opacity: 1;
}

:host-context(.isDarkTheme) .kichat-session-delete:hover {
    background: rgba(255, 255, 255, 0.1);
}

.kichat-session-delete mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
}

.kichat-rename-input {
    width: 100%;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid var(--primary-color, #1976d2);
    background: var(--background-color, #fff);
    color: inherit;
    font: inherit;
    font-size: 0.88rem;
    outline: none;
}

.kichat-sessions-empty {
    padding: 16px 12px;
    font-size: 0.85rem;
    opacity: 0.5;
    text-align: center;
}

/* ---------- Message list ---------- */
.kichat-messages {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 24px 16px 8px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    scroll-behavior: smooth;
}

.kichat-empty {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    opacity: 0.55;
    text-align: center;
    padding: 32px 16px;
}

.kichat-empty-icon {
    font-size: 40px;
    width: 40px;
    height: 40px;
}

.kichat-empty-text {
    font-size: 0.95rem;
    max-width: 320px;
    line-height: 1.4;
}

.kichat-row {
    display: flex;
    gap: 10px;
    width: 100%;
    align-items: flex-start;
}

.kichat-row-user {
    justify-content: flex-end;
}

.kichat-row-assistant,
.kichat-row-system {
    justify-content: flex-start;
}

.kichat-avatar {
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: linear-gradient(135deg, #7e57c2 0%, #5e35b1 100%);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2px;
}

.kichat-avatar mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
}

.kichat-msg {
    display: flex;
    flex-direction: column;
    max-width: 75%;
}

.kichat-actions {
    display: flex;
    gap: 4px;
    margin-top: 4px;
    opacity: 0;
    transition: opacity 0.15s;
}

.kichat-row:hover .kichat-actions,
.kichat-actions:focus-within {
    opacity: 1;
}

/* Hover toolbar under a user bubble: time + retry/edit/copy, right-aligned to the bubble. */
.kichat-user-meta {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 2px;
    margin-top: 4px;
    opacity: 0;
    transition: opacity 0.15s;
}

.kichat-row:hover .kichat-user-meta,
.kichat-user-meta:focus-within {
    opacity: 1;
}

.kichat-user-time {
    font-size: 0.75rem;
    opacity: 0.6;
    margin-right: 6px;
}

.kichat-action {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    border: none;
    background: transparent;
    color: inherit;
    opacity: 0.65;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.kichat-action:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.06);
    opacity: 1;
}

:host-context(.isDarkTheme) .kichat-action:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
}

.kichat-action:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.kichat-action mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
}

.kichat-row-user .kichat-msg {
    justify-content: flex-end;
}

.kichat-bubble {
    padding: 10px 14px;
    border-radius: 18px;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.5;
    font-size: 0.95rem;
}

.kichat-row-user .kichat-bubble {
    background: var(--primary-color, #1976d2);
    color: var(--primary-contrast, #fff);
    border-bottom-right-radius: 4px;
}

.kichat-row-assistant .kichat-bubble {
    background: rgba(0, 0, 0, 0.04);
    color: inherit;
    border-bottom-left-radius: 4px;
}

/* ---------- Markdown content (assistant bubbles) ----------
   The bubble body is injected via [innerHTML], so its child nodes are NOT created from this
   component's template and don't carry the emulated-encapsulation attribute. Scoped selectors
   therefore can't reach them — every rule targeting a markdown descendant must pierce with
   ::ng-deep. The rules stay anchored under .kichat-bubble-md (a template element), so they
   still only affect this component's bubbles and don't leak globally. */
.kichat-bubble-md {
    white-space: normal;
    overflow-x: auto;
}

.kichat-bubble-md ::ng-deep > *:first-child { margin-top: 0; }
.kichat-bubble-md ::ng-deep > *:last-child  { margin-bottom: 0; }

.kichat-bubble-md ::ng-deep p {
    margin: 0 0 8px;
    white-space: pre-wrap;
}

.kichat-bubble-md ::ng-deep ul,
.kichat-bubble-md ::ng-deep ol {
    margin: 4px 0 8px;
    padding-left: 22px;
}

.kichat-bubble-md ::ng-deep li { margin: 2px 0; }

.kichat-bubble-md ::ng-deep h1,
.kichat-bubble-md ::ng-deep h2,
.kichat-bubble-md ::ng-deep h3,
.kichat-bubble-md ::ng-deep h4 {
    margin: 10px 0 6px;
    font-weight: 600;
    line-height: 1.3;
}
.kichat-bubble-md ::ng-deep h1 { font-size: 1.15rem; }
.kichat-bubble-md ::ng-deep h2 { font-size: 1.08rem; }
.kichat-bubble-md ::ng-deep h3 { font-size: 1.02rem; }
.kichat-bubble-md ::ng-deep h4 { font-size: 0.98rem; }

.kichat-bubble-md ::ng-deep code {
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 0.88em;
    background: rgba(0, 0, 0, 0.06);
    padding: 1px 5px;
    border-radius: 4px;
}

:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep code {
    background: rgba(255, 255, 255, 0.1);
}

/* Data card: the structured parts of a response (fenced code blocks and tables) get a
   header bar (label + copy control) over a body shaded slightly differently from the
   surrounding bubble, so data stands apart from ordinary prose. */
.kichat-bubble-md ::ng-deep .kichat-data {
    margin: 8px 0;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.03);
}

/* Mermaid diagram card: a rendered <svg> is centered and scaled to fit; until it renders
   (or if rendering fails) the raw diagram source is shown as a monospace fallback. */
.kichat-bubble-md ::ng-deep .kichat-mermaid {
    padding: 10px 12px;
    text-align: center;
    overflow-x: auto;
}

.kichat-bubble-md ::ng-deep .kichat-mermaid svg {
    max-width: 100%;
    height: auto;
    display: inline-block;
}

.kichat-bubble-md ::ng-deep .kichat-mermaid-src {
    white-space: pre-wrap;
    text-align: left;
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 0.85em;
    opacity: 0.7;
}

.kichat-bubble-md ::ng-deep .kichat-mermaid-error {
    border-color: rgba(200, 0, 0, 0.4);
}

.kichat-bubble-md ::ng-deep .kichat-data-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 3px 6px 3px 12px;
    background: rgba(0, 0, 0, 0.06);
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.kichat-bubble-md ::ng-deep .kichat-data-label {
    text-transform: lowercase;
    letter-spacing: 0.02em;
    opacity: 0.6;
    font-size: 0.75rem;
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

.kichat-bubble-md ::ng-deep .kichat-data-copy {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 8px;
    border-radius: 6px;
    cursor: pointer;
    opacity: 0.7;
    -webkit-user-select: none;
            user-select: none;
    transition: background-color 0.15s ease, opacity 0.15s ease, color 0.15s ease;
}

.kichat-bubble-md ::ng-deep .kichat-data-copy:hover {
    background: rgba(0, 0, 0, 0.08);
    opacity: 1;
}

.kichat-bubble-md ::ng-deep .kichat-data-copy.is-copied {
    opacity: 1;
    color: var(--primary-color, #1976d2);
}

/* Override the global \`.material-icons { font-size: 0 }\` (a FOUC guard) so the glyph shows. */
.kichat-bubble-md ::ng-deep .kichat-data-copy-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
    line-height: 16px;
}

.kichat-bubble-md ::ng-deep .kichat-data-copy-label {
    font-size: 0.75rem;
}

/* Code card body */
.kichat-bubble-md ::ng-deep .kichat-code pre {
    background: transparent;
    margin: 0;
    padding: 10px 12px;
    border-radius: 0;
    overflow-x: auto;
}

.kichat-bubble-md ::ng-deep pre code {
    background: transparent;
    padding: 0;
    border-radius: 0;
    font-size: 0.85em;
}

/* Tables are framed with a dashed delimiter so they read clearly as data, with the copy
   control floated into the top-right corner inside that frame. */
.kichat-bubble-md ::ng-deep .kichat-table {
    position: relative;
    border-style: dashed;
    border-width: 1.5px;
    border-color: rgba(0, 0, 0, 0.3);
}

.kichat-bubble-md ::ng-deep .kichat-table-copy {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 1;
    padding: 4px;
    background: var(--background-color, #fff);
    border: 1px solid rgba(0, 0, 0, 0.12);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

/* Table card body: edge-to-edge grid, scrolls horizontally when it overflows. The right
   padding keeps the first header cell's text clear of the floated copy control. */
.kichat-bubble-md ::ng-deep .kichat-table-scroll {
    overflow-x: auto;
}

.kichat-bubble-md ::ng-deep .kichat-table thead th:last-child {
    padding-right: 44px;
}

.kichat-bubble-md ::ng-deep .kichat-table table {
    margin: 0;
    width: 100%;
    border: 0;
    max-width: none;
}

.kichat-bubble-md ::ng-deep .kichat-table th {
    background: rgba(0, 0, 0, 0.03);
}

:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-data {
    border-color: rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.05);
}

:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-data-head {
    background: rgba(255, 255, 255, 0.09);
    border-bottom-color: rgba(255, 255, 255, 0.1);
}

:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-data-copy:hover {
    background: rgba(255, 255, 255, 0.12);
}

:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-data-copy.is-copied {
    color: var(--primary-color, #90caf9);
}

:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-table th {
    background: rgba(255, 255, 255, 0.04);
}

:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-table {
    border-color: rgba(255, 255, 255, 0.32);
}

:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-table-copy {
    border-color: rgba(255, 255, 255, 0.18);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

.kichat-bubble-md ::ng-deep blockquote {
    margin: 6px 0;
    padding: 4px 12px;
    border-left: 3px solid rgba(0, 0, 0, 0.2);
    color: inherit;
    opacity: 0.85;
}

:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep blockquote {
    border-left-color: rgba(255, 255, 255, 0.25);
}

.kichat-bubble-md ::ng-deep a {
    color: var(--primary-color, #1976d2);
    text-decoration: underline;
}

.kichat-bubble-md ::ng-deep table {
    border-collapse: collapse;
    margin: 8px 0;
    font-size: 0.9rem;
    width: auto;
    max-width: 100%;
}

.kichat-bubble-md ::ng-deep th,
.kichat-bubble-md ::ng-deep td {
    border: 1px solid rgba(0, 0, 0, 0.18);
    padding: 6px 10px;
    text-align: left;
    vertical-align: top;
}

.kichat-bubble-md ::ng-deep th {
    background: rgba(0, 0, 0, 0.04);
    font-weight: 600;
}

.kichat-bubble-md ::ng-deep tr:nth-child(even) td {
    background: rgba(0, 0, 0, 0.02);
}

:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep th,
:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep td {
    border-color: rgba(255, 255, 255, 0.18);
}
:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep th {
    background: rgba(255, 255, 255, 0.06);
}
:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep tr:nth-child(even) td {
    background: rgba(255, 255, 255, 0.03);
}

:host-context(.isDarkTheme) .kichat-row-assistant .kichat-bubble {
    background: rgba(255, 255, 255, 0.06);
}

/* ---------- Typing indicator ---------- */
.kichat-typing {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 14px 16px;
}

.kichat-typing span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
    opacity: 0.4;
    animation: kichat-bounce 1.2s infinite ease-in-out;
}

.kichat-typing span:nth-child(2) { animation-delay: 0.15s; }
.kichat-typing span:nth-child(3) { animation-delay: 0.3s; }

@keyframes kichat-bounce {
    0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
    40%           { transform: translateY(-4px); opacity: 1; }
}

/* ---------- Error ---------- */
.kichat-error {
    align-self: center;
    color: #b00020;
    background: rgba(176, 0, 32, 0.08);
    border-radius: 8px;
    padding: 6px 12px;
    font-size: 0.85rem;
}

/* ---------- Composer ---------- */
.kichat-composer {
    flex: 0 0 auto;
    padding: 8px 12px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.kichat-composer-inner {
    position: relative;
    display: flex;
    align-items: flex-end;
    width: 100%;
    max-width: 760px;
    background: var(--background-color, #fff);
    border: 1px solid rgba(0, 0, 0, 0.18);
    border-radius: 22px;
    padding: 6px 6px 6px 14px;
    transition: border-color 0.15s, box-shadow 0.15s;
}

.kichat-composer-inner:focus-within {
    border-color: var(--primary-color, #1976d2);
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.12);
}

:host-context(.isDarkTheme) .kichat-composer-inner {
    border-color: rgba(255, 255, 255, 0.2);
}

.kichat-input {
    flex: 1 1 auto;
    resize: none;
    border: none;
    outline: none;
    background: transparent;
    color: inherit;
    font: inherit;
    font-size: 0.95rem;
    line-height: 1.4;
    padding: 6px 4px;
    max-height: 200px;
    overflow-y: auto;
}

.kichat-input::placeholder {
    opacity: 0.5;
}

.kichat-mic {
    flex: 0 0 auto;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: transparent;
    color: inherit;
    opacity: 0.7;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 4px;
    align-self: flex-end;
    transition: background 0.15s, color 0.15s, opacity 0.15s;
}

.kichat-mic:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.06);
    opacity: 1;
}

:host-context(.isDarkTheme) .kichat-mic:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
}

.kichat-mic.recording {
    color: #d32f2f;
    opacity: 1;
    animation: kichat-pulse 1.4s infinite;
}

.kichat-mic:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.kichat-mic mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
}

@keyframes kichat-pulse {
    0%, 100% { opacity: 1; }
    50%      { opacity: 0.45; }
}

.kichat-send {
    flex: 0 0 auto;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: var(--primary-color, #1976d2);
    color: var(--primary-contrast, #fff);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, transform 0.1s;
    margin-left: 4px;
    align-self: flex-end;
}

.kichat-send:hover:not(:disabled) {
    transform: scale(1.05);
}

.kichat-send:disabled {
    background: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.38);
    cursor: not-allowed;
}

:host-context(.isDarkTheme) .kichat-send:disabled {
    background: rgba(255, 255, 255, 0.12);
    color: rgba(255, 255, 255, 0.4);
}

.kichat-send mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
}

/* Stop variant: while a query is in flight, the same button cancels it. */
.kichat-send.kichat-stop {
    background: #b00020;
}

.kichat-send.kichat-stop:hover:not(:disabled) {
    background: #8c001a;
}

.kichat-context-indicator {
    width: 100%;
    max-width: 760px;
    text-align: right;
    font-size: 0.72rem;
    color: rgba(0, 0, 0, 0.45);
    padding: 0 8px;
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
}

:host-context(.isDarkTheme) .kichat-context-indicator {
    color: rgba(255, 255, 255, 0.4);
}

.kichat-time {
    font-size: 0.7rem;
    color: rgba(0, 0, 0, 0.45);
    padding: 2px 4px 0;
    -webkit-user-select: none;
            user-select: none;
    font-variant-numeric: tabular-nums;
}

:host-context(.isDarkTheme) .kichat-time {
    color: rgba(255, 255, 255, 0.4);
}

/* ---------- Next-steps suggestion chips ---------- */
.kichat-nextsteps {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
}

.kichat-nextstep {
    max-width: 100%;
    text-align: left;
    padding: 6px 12px;
    border-radius: 16px;
    border: 1px solid var(--primary-color, #1976d2);
    background: var(--background-color, #fff);
    color: var(--primary-color, #1976d2);
    font-size: 0.8rem;
    line-height: 1.3;
    cursor: pointer;
    white-space: normal;
    transition: background 0.15s, color 0.15s;
}

.kichat-nextstep:hover {
    background: var(--primary-color, #1976d2);
    color: var(--primary-contrast, #fff);
}

:host-context(.isDarkTheme) .kichat-nextstep {
    background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/kichat/kichat.control.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,yCAAyC;IACzC,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,iEAAiE;AACjE;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA,iCAAiC;AACjC;IACI,cAAc;IACd,QAAQ;IACR,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;IAC1C,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,4CAA4C;IAC5C,qCAAqC;AACzC;;AAEA,qFAAqF;AACrF;IACI,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,yCAAyC;IACzC,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,qCAAqC;AACzC;;AAEA;6EAC6E;AAC7E;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;IACzC,cAAc;IACd,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,+CAA+C;IAC/C,yCAAyC;IACzC,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA,uCAAuC;AACvC;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6DAA6D;IAC7D,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,UAAU;IACV,yBAAyB;AAC7B;;AAEA;;IAEI,UAAU;AACd;;AAEA,4FAA4F;AAC5F;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,eAAe;IACf,UAAU;IACV,yBAAyB;AAC7B;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,cAAc;IACd,8BAA8B;AAClC;;AAEA;;;;;wEAKwE;AACxE;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,8CAA8C,aAAa,EAAE;AAC7D,8CAA8C,gBAAgB,EAAE;;AAEhE;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,iCAAiC,aAAa,EAAE;;AAEhD;;;;IAII,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;AACA,iCAAiC,kBAAkB,EAAE;AACrD,iCAAiC,kBAAkB,EAAE;AACrD,iCAAiC,kBAAkB,EAAE;AACrD,iCAAiC,kBAAkB,EAAE;;AAErD;IACI,qEAAqE;IACrE,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;kEAEkE;AAClE;IACI,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;qFACqF;AACrF;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,qEAAqE;IACrE,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,yBAAyB;IACzB,+BAA+B;IAC/B,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,qEAAqE;AACzE;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,6EAA6E;AACjF;;AAEA;IACI,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,UAAU;IACV,oCAAoC;AACxC;;AAEA,8FAA8F;AAC9F;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;iEACiE;AACjE;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,YAAY;IACZ,yCAAyC;IACzC,qCAAqC;IACrC,yCAAyC;AAC7C;;AAEA;kFACkF;AAClF;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uCAAuC;IACvC,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,yCAAyC;IACzC,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,qCAAqC;IACrC,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;IAEI,uCAAuC;AAC3C;AACA;IACI,qCAAqC;AACzC;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA,2CAA2C;AAC3C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,kDAAkD;AACtD;;AAEA,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;;AAE1D;IACI,gBAAgB,wBAAwB,EAAE,YAAY,EAAE;IACxD,gBAAgB,2BAA2B,EAAE,UAAU,EAAE;AAC7D;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,cAAc;IACd,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,mCAAmC;AACnC;IACI,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,yCAAyC;IACzC,qCAAqC;IACrC,mBAAmB;IACnB,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA;IACI,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,wDAAwD;AAC5D;;AAEA;IACI,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,WAAW,aAAa,EAAE;AAC9B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;IACzC,oCAAoC;IACpC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4CAA4C;IAC5C,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA,0EAA0E;AAC1E;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,cAAc;IACd,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,+BAA+B;AACnC;;AAEA,sDAAsD;AACtD;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,+CAA+C;IAC/C,yCAAyC;IACzC,oCAAoC;IACpC,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;IACzC,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[":host {\n    display: block;\n    width: 100%;\n    height: 100%;\n}\n\n.kichat-root {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 280px;\n    background: var(--background-color, #fff);\n    color: inherit;\n    overflow: hidden;\n    font-family: inherit;\n}\n\n.kichat-root.has-drawer {\n    flex-direction: row-reverse;\n}\n\n/* Drawer on the left side (opt-in via the TopicsLeft property) */\n.kichat-root.has-drawer.drawer-left {\n    flex-direction: row;\n}\n\n.kichat-main {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    position: relative;\n}\n\n/* ---------- Drawer ---------- */\n.kichat-drawer {\n    flex: 0 0 auto;\n    width: 0;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    border-left: 1px solid rgba(0, 0, 0, 0.08);\n    background: rgba(0, 0, 0, 0.02);\n    transition: width 0.2s ease;\n}\n\n.kichat-root.drawer-open .kichat-drawer {\n    width: 260px;\n}\n\n:host-context(.isDarkTheme) .kichat-drawer {\n    border-left-color: rgba(255, 255, 255, 0.08);\n    background: rgba(255, 255, 255, 0.03);\n}\n\n/* When the drawer sits on the left, the separating border moves to its right edge. */\n.kichat-root.drawer-left .kichat-drawer {\n    border-left: 0;\n    border-right: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n:host-context(.isDarkTheme) .kichat-root.drawer-left .kichat-drawer {\n    border-right-color: rgba(255, 255, 255, 0.08);\n}\n\n.kichat-drawer-header {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 8px 8px 12px;\n    min-height: 44px;\n}\n\n.kichat-drawer-title {\n    flex: 1 1 auto;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    opacity: 0.6;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.kichat-drawer-toggle {\n    flex: 0 0 auto;\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: none;\n    background: transparent;\n    color: inherit;\n    opacity: 0.7;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n}\n\n.kichat-drawer-toggle:hover:not(:disabled) {\n    background: rgba(0, 0, 0, 0.06);\n    opacity: 1;\n}\n\n:host-context(.isDarkTheme) .kichat-drawer-toggle:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.kichat-drawer-toggle mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n}\n\n.kichat-drawer-toggle-floating {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    z-index: 2;\n    background: var(--background-color, #fff);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.kichat-root.drawer-left .kichat-drawer-toggle-floating {\n    right: auto;\n    left: 8px;\n}\n\n:host-context(.isDarkTheme) .kichat-drawer-toggle-floating {\n    background: rgba(255, 255, 255, 0.06);\n}\n\n/* Floating \"Export as HTML\" action (top-right of the chat pane). Shifts left to sit beside\n   the floating drawer toggle when that toggle shares the top-right corner. */\n.kichat-export-btn {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    z-index: 2;\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: none;\n    background: var(--background-color, #fff);\n    color: inherit;\n    opacity: 0.7;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.kichat-export-btn:hover {\n    opacity: 1;\n}\n\n.kichat-export-btn.kichat-export-shifted {\n    right: 48px;\n}\n\n:host-context(.isDarkTheme) .kichat-export-btn {\n    background: rgba(255, 255, 255, 0.06);\n}\n\n.kichat-export-btn mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n}\n\n.kichat-drawer-new {\n    flex: 0 0 auto;\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: none;\n    background: transparent;\n    color: inherit;\n    opacity: 0.7;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n}\n\n.kichat-drawer-new:hover:not(:disabled) {\n    background: rgba(0, 0, 0, 0.06);\n    opacity: 1;\n}\n\n:host-context(.isDarkTheme) .kichat-drawer-new:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.kichat-drawer-new:disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n}\n\n.kichat-drawer-new mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n}\n\n.kichat-drawer-body {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    padding: 4px 8px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.kichat-session {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 10px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 0.88rem;\n    line-height: 1.3;\n    color: inherit;\n    background: transparent;\n    border: none;\n    text-align: left;\n    width: 100%;\n}\n\n.kichat-session:hover {\n    background: rgba(0, 0, 0, 0.05);\n}\n\n:host-context(.isDarkTheme) .kichat-session:hover {\n    background: rgba(255, 255, 255, 0.06);\n}\n\n.kichat-session.active {\n    background: rgba(25, 118, 210, 0.12);\n}\n\n:host-context(.isDarkTheme) .kichat-session.active {\n    background: rgba(144, 202, 249, 0.18);\n}\n\n.kichat-session-icon {\n    flex: 0 0 18px;\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    opacity: 0.7;\n}\n\n.kichat-session-name {\n    flex: 1 1 auto;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.kichat-session-delete {\n    flex: 0 0 auto;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    border: none;\n    background: transparent;\n    color: inherit;\n    opacity: 0;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n}\n\n.kichat-session:hover .kichat-session-delete {\n    opacity: 0.7;\n}\n\n.kichat-session-delete:hover {\n    background: rgba(0, 0, 0, 0.08);\n    opacity: 1;\n}\n\n:host-context(.isDarkTheme) .kichat-session-delete:hover {\n    background: rgba(255, 255, 255, 0.1);\n}\n\n.kichat-session-delete mat-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n}\n\n.kichat-rename-input {\n    width: 100%;\n    padding: 8px 10px;\n    border-radius: 8px;\n    border: 1px solid var(--primary-color, #1976d2);\n    background: var(--background-color, #fff);\n    color: inherit;\n    font: inherit;\n    font-size: 0.88rem;\n    outline: none;\n}\n\n.kichat-sessions-empty {\n    padding: 16px 12px;\n    font-size: 0.85rem;\n    opacity: 0.5;\n    text-align: center;\n}\n\n/* ---------- Message list ---------- */\n.kichat-messages {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    padding: 24px 16px 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    scroll-behavior: smooth;\n}\n\n.kichat-empty {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    opacity: 0.55;\n    text-align: center;\n    padding: 32px 16px;\n}\n\n.kichat-empty-icon {\n    font-size: 40px;\n    width: 40px;\n    height: 40px;\n}\n\n.kichat-empty-text {\n    font-size: 0.95rem;\n    max-width: 320px;\n    line-height: 1.4;\n}\n\n.kichat-row {\n    display: flex;\n    gap: 10px;\n    width: 100%;\n    align-items: flex-start;\n}\n\n.kichat-row-user {\n    justify-content: flex-end;\n}\n\n.kichat-row-assistant,\n.kichat-row-system {\n    justify-content: flex-start;\n}\n\n.kichat-avatar {\n    flex: 0 0 28px;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #7e57c2 0%, #5e35b1 100%);\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 2px;\n}\n\n.kichat-avatar mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n}\n\n.kichat-msg {\n    display: flex;\n    flex-direction: column;\n    max-width: 75%;\n}\n\n.kichat-actions {\n    display: flex;\n    gap: 4px;\n    margin-top: 4px;\n    opacity: 0;\n    transition: opacity 0.15s;\n}\n\n.kichat-row:hover .kichat-actions,\n.kichat-actions:focus-within {\n    opacity: 1;\n}\n\n/* Hover toolbar under a user bubble: time + retry/edit/copy, right-aligned to the bubble. */\n.kichat-user-meta {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 2px;\n    margin-top: 4px;\n    opacity: 0;\n    transition: opacity 0.15s;\n}\n\n.kichat-row:hover .kichat-user-meta,\n.kichat-user-meta:focus-within {\n    opacity: 1;\n}\n\n.kichat-user-time {\n    font-size: 0.75rem;\n    opacity: 0.6;\n    margin-right: 6px;\n}\n\n.kichat-action {\n    width: 26px;\n    height: 26px;\n    border-radius: 6px;\n    border: none;\n    background: transparent;\n    color: inherit;\n    opacity: 0.65;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n}\n\n.kichat-action:hover:not(:disabled) {\n    background: rgba(0, 0, 0, 0.06);\n    opacity: 1;\n}\n\n:host-context(.isDarkTheme) .kichat-action:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.kichat-action:disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n}\n\n.kichat-action mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n}\n\n.kichat-row-user .kichat-msg {\n    justify-content: flex-end;\n}\n\n.kichat-bubble {\n    padding: 10px 14px;\n    border-radius: 18px;\n    white-space: pre-wrap;\n    word-break: break-word;\n    line-height: 1.5;\n    font-size: 0.95rem;\n}\n\n.kichat-row-user .kichat-bubble {\n    background: var(--primary-color, #1976d2);\n    color: var(--primary-contrast, #fff);\n    border-bottom-right-radius: 4px;\n}\n\n.kichat-row-assistant .kichat-bubble {\n    background: rgba(0, 0, 0, 0.04);\n    color: inherit;\n    border-bottom-left-radius: 4px;\n}\n\n/* ---------- Markdown content (assistant bubbles) ----------\n   The bubble body is injected via [innerHTML], so its child nodes are NOT created from this\n   component's template and don't carry the emulated-encapsulation attribute. Scoped selectors\n   therefore can't reach them — every rule targeting a markdown descendant must pierce with\n   ::ng-deep. The rules stay anchored under .kichat-bubble-md (a template element), so they\n   still only affect this component's bubbles and don't leak globally. */\n.kichat-bubble-md {\n    white-space: normal;\n    overflow-x: auto;\n}\n\n.kichat-bubble-md ::ng-deep > *:first-child { margin-top: 0; }\n.kichat-bubble-md ::ng-deep > *:last-child  { margin-bottom: 0; }\n\n.kichat-bubble-md ::ng-deep p {\n    margin: 0 0 8px;\n    white-space: pre-wrap;\n}\n\n.kichat-bubble-md ::ng-deep ul,\n.kichat-bubble-md ::ng-deep ol {\n    margin: 4px 0 8px;\n    padding-left: 22px;\n}\n\n.kichat-bubble-md ::ng-deep li { margin: 2px 0; }\n\n.kichat-bubble-md ::ng-deep h1,\n.kichat-bubble-md ::ng-deep h2,\n.kichat-bubble-md ::ng-deep h3,\n.kichat-bubble-md ::ng-deep h4 {\n    margin: 10px 0 6px;\n    font-weight: 600;\n    line-height: 1.3;\n}\n.kichat-bubble-md ::ng-deep h1 { font-size: 1.15rem; }\n.kichat-bubble-md ::ng-deep h2 { font-size: 1.08rem; }\n.kichat-bubble-md ::ng-deep h3 { font-size: 1.02rem; }\n.kichat-bubble-md ::ng-deep h4 { font-size: 0.98rem; }\n\n.kichat-bubble-md ::ng-deep code {\n    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n    font-size: 0.88em;\n    background: rgba(0, 0, 0, 0.06);\n    padding: 1px 5px;\n    border-radius: 4px;\n}\n\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep code {\n    background: rgba(255, 255, 255, 0.1);\n}\n\n/* Data card: the structured parts of a response (fenced code blocks and tables) get a\n   header bar (label + copy control) over a body shaded slightly differently from the\n   surrounding bubble, so data stands apart from ordinary prose. */\n.kichat-bubble-md ::ng-deep .kichat-data {\n    margin: 8px 0;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    overflow: hidden;\n    background: rgba(0, 0, 0, 0.03);\n}\n\n/* Mermaid diagram card: a rendered <svg> is centered and scaled to fit; until it renders\n   (or if rendering fails) the raw diagram source is shown as a monospace fallback. */\n.kichat-bubble-md ::ng-deep .kichat-mermaid {\n    padding: 10px 12px;\n    text-align: center;\n    overflow-x: auto;\n}\n\n.kichat-bubble-md ::ng-deep .kichat-mermaid svg {\n    max-width: 100%;\n    height: auto;\n    display: inline-block;\n}\n\n.kichat-bubble-md ::ng-deep .kichat-mermaid-src {\n    white-space: pre-wrap;\n    text-align: left;\n    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n    font-size: 0.85em;\n    opacity: 0.7;\n}\n\n.kichat-bubble-md ::ng-deep .kichat-mermaid-error {\n    border-color: rgba(200, 0, 0, 0.4);\n}\n\n.kichat-bubble-md ::ng-deep .kichat-data-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 3px 6px 3px 12px;\n    background: rgba(0, 0, 0, 0.06);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.kichat-bubble-md ::ng-deep .kichat-data-label {\n    text-transform: lowercase;\n    letter-spacing: 0.02em;\n    opacity: 0.6;\n    font-size: 0.75rem;\n    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n}\n\n.kichat-bubble-md ::ng-deep .kichat-data-copy {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 3px 8px;\n    border-radius: 6px;\n    cursor: pointer;\n    opacity: 0.7;\n    user-select: none;\n    transition: background-color 0.15s ease, opacity 0.15s ease, color 0.15s ease;\n}\n\n.kichat-bubble-md ::ng-deep .kichat-data-copy:hover {\n    background: rgba(0, 0, 0, 0.08);\n    opacity: 1;\n}\n\n.kichat-bubble-md ::ng-deep .kichat-data-copy.is-copied {\n    opacity: 1;\n    color: var(--primary-color, #1976d2);\n}\n\n/* Override the global `.material-icons { font-size: 0 }` (a FOUC guard) so the glyph shows. */\n.kichat-bubble-md ::ng-deep .kichat-data-copy-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n}\n\n.kichat-bubble-md ::ng-deep .kichat-data-copy-label {\n    font-size: 0.75rem;\n}\n\n/* Code card body */\n.kichat-bubble-md ::ng-deep .kichat-code pre {\n    background: transparent;\n    margin: 0;\n    padding: 10px 12px;\n    border-radius: 0;\n    overflow-x: auto;\n}\n\n.kichat-bubble-md ::ng-deep pre code {\n    background: transparent;\n    padding: 0;\n    border-radius: 0;\n    font-size: 0.85em;\n}\n\n/* Tables are framed with a dashed delimiter so they read clearly as data, with the copy\n   control floated into the top-right corner inside that frame. */\n.kichat-bubble-md ::ng-deep .kichat-table {\n    position: relative;\n    border-style: dashed;\n    border-width: 1.5px;\n    border-color: rgba(0, 0, 0, 0.3);\n}\n\n.kichat-bubble-md ::ng-deep .kichat-table-copy {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    z-index: 1;\n    padding: 4px;\n    background: var(--background-color, #fff);\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);\n}\n\n/* Table card body: edge-to-edge grid, scrolls horizontally when it overflows. The right\n   padding keeps the first header cell's text clear of the floated copy control. */\n.kichat-bubble-md ::ng-deep .kichat-table-scroll {\n    overflow-x: auto;\n}\n\n.kichat-bubble-md ::ng-deep .kichat-table thead th:last-child {\n    padding-right: 44px;\n}\n\n.kichat-bubble-md ::ng-deep .kichat-table table {\n    margin: 0;\n    width: 100%;\n    border: 0;\n    max-width: none;\n}\n\n.kichat-bubble-md ::ng-deep .kichat-table th {\n    background: rgba(0, 0, 0, 0.03);\n}\n\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-data {\n    border-color: rgba(255, 255, 255, 0.12);\n    background: rgba(255, 255, 255, 0.05);\n}\n\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-data-head {\n    background: rgba(255, 255, 255, 0.09);\n    border-bottom-color: rgba(255, 255, 255, 0.1);\n}\n\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-data-copy:hover {\n    background: rgba(255, 255, 255, 0.12);\n}\n\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-data-copy.is-copied {\n    color: var(--primary-color, #90caf9);\n}\n\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-table th {\n    background: rgba(255, 255, 255, 0.04);\n}\n\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-table {\n    border-color: rgba(255, 255, 255, 0.32);\n}\n\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep .kichat-table-copy {\n    border-color: rgba(255, 255, 255, 0.18);\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);\n}\n\n.kichat-bubble-md ::ng-deep blockquote {\n    margin: 6px 0;\n    padding: 4px 12px;\n    border-left: 3px solid rgba(0, 0, 0, 0.2);\n    color: inherit;\n    opacity: 0.85;\n}\n\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep blockquote {\n    border-left-color: rgba(255, 255, 255, 0.25);\n}\n\n.kichat-bubble-md ::ng-deep a {\n    color: var(--primary-color, #1976d2);\n    text-decoration: underline;\n}\n\n.kichat-bubble-md ::ng-deep table {\n    border-collapse: collapse;\n    margin: 8px 0;\n    font-size: 0.9rem;\n    width: auto;\n    max-width: 100%;\n}\n\n.kichat-bubble-md ::ng-deep th,\n.kichat-bubble-md ::ng-deep td {\n    border: 1px solid rgba(0, 0, 0, 0.18);\n    padding: 6px 10px;\n    text-align: left;\n    vertical-align: top;\n}\n\n.kichat-bubble-md ::ng-deep th {\n    background: rgba(0, 0, 0, 0.04);\n    font-weight: 600;\n}\n\n.kichat-bubble-md ::ng-deep tr:nth-child(even) td {\n    background: rgba(0, 0, 0, 0.02);\n}\n\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep th,\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep td {\n    border-color: rgba(255, 255, 255, 0.18);\n}\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep th {\n    background: rgba(255, 255, 255, 0.06);\n}\n:host-context(.isDarkTheme) .kichat-bubble-md ::ng-deep tr:nth-child(even) td {\n    background: rgba(255, 255, 255, 0.03);\n}\n\n:host-context(.isDarkTheme) .kichat-row-assistant .kichat-bubble {\n    background: rgba(255, 255, 255, 0.06);\n}\n\n/* ---------- Typing indicator ---------- */\n.kichat-typing {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 14px 16px;\n}\n\n.kichat-typing span {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: currentColor;\n    opacity: 0.4;\n    animation: kichat-bounce 1.2s infinite ease-in-out;\n}\n\n.kichat-typing span:nth-child(2) { animation-delay: 0.15s; }\n.kichat-typing span:nth-child(3) { animation-delay: 0.3s; }\n\n@keyframes kichat-bounce {\n    0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }\n    40%           { transform: translateY(-4px); opacity: 1; }\n}\n\n/* ---------- Error ---------- */\n.kichat-error {\n    align-self: center;\n    color: #b00020;\n    background: rgba(176, 0, 32, 0.08);\n    border-radius: 8px;\n    padding: 6px 12px;\n    font-size: 0.85rem;\n}\n\n/* ---------- Composer ---------- */\n.kichat-composer {\n    flex: 0 0 auto;\n    padding: 8px 12px 12px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n}\n\n.kichat-composer-inner {\n    position: relative;\n    display: flex;\n    align-items: flex-end;\n    width: 100%;\n    max-width: 760px;\n    background: var(--background-color, #fff);\n    border: 1px solid rgba(0, 0, 0, 0.18);\n    border-radius: 22px;\n    padding: 6px 6px 6px 14px;\n    transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.kichat-composer-inner:focus-within {\n    border-color: var(--primary-color, #1976d2);\n    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.12);\n}\n\n:host-context(.isDarkTheme) .kichat-composer-inner {\n    border-color: rgba(255, 255, 255, 0.2);\n}\n\n.kichat-input {\n    flex: 1 1 auto;\n    resize: none;\n    border: none;\n    outline: none;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    font-size: 0.95rem;\n    line-height: 1.4;\n    padding: 6px 4px;\n    max-height: 200px;\n    overflow-y: auto;\n}\n\n.kichat-input::placeholder {\n    opacity: 0.5;\n}\n\n.kichat-mic {\n    flex: 0 0 auto;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: none;\n    background: transparent;\n    color: inherit;\n    opacity: 0.7;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 4px;\n    align-self: flex-end;\n    transition: background 0.15s, color 0.15s, opacity 0.15s;\n}\n\n.kichat-mic:hover:not(:disabled) {\n    background: rgba(0, 0, 0, 0.06);\n    opacity: 1;\n}\n\n:host-context(.isDarkTheme) .kichat-mic:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.kichat-mic.recording {\n    color: #d32f2f;\n    opacity: 1;\n    animation: kichat-pulse 1.4s infinite;\n}\n\n.kichat-mic:disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n}\n\n.kichat-mic mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n}\n\n@keyframes kichat-pulse {\n    0%, 100% { opacity: 1; }\n    50%      { opacity: 0.45; }\n}\n\n.kichat-send {\n    flex: 0 0 auto;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: none;\n    background: var(--primary-color, #1976d2);\n    color: var(--primary-contrast, #fff);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.15s, transform 0.1s;\n    margin-left: 4px;\n    align-self: flex-end;\n}\n\n.kichat-send:hover:not(:disabled) {\n    transform: scale(1.05);\n}\n\n.kichat-send:disabled {\n    background: rgba(0, 0, 0, 0.12);\n    color: rgba(0, 0, 0, 0.38);\n    cursor: not-allowed;\n}\n\n:host-context(.isDarkTheme) .kichat-send:disabled {\n    background: rgba(255, 255, 255, 0.12);\n    color: rgba(255, 255, 255, 0.4);\n}\n\n.kichat-send mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n}\n\n/* Stop variant: while a query is in flight, the same button cancels it. */\n.kichat-send.kichat-stop {\n    background: #b00020;\n}\n\n.kichat-send.kichat-stop:hover:not(:disabled) {\n    background: #8c001a;\n}\n\n.kichat-context-indicator {\n    width: 100%;\n    max-width: 760px;\n    text-align: right;\n    font-size: 0.72rem;\n    color: rgba(0, 0, 0, 0.45);\n    padding: 0 8px;\n    pointer-events: none;\n    user-select: none;\n}\n\n:host-context(.isDarkTheme) .kichat-context-indicator {\n    color: rgba(255, 255, 255, 0.4);\n}\n\n.kichat-time {\n    font-size: 0.7rem;\n    color: rgba(0, 0, 0, 0.45);\n    padding: 2px 4px 0;\n    user-select: none;\n    font-variant-numeric: tabular-nums;\n}\n\n:host-context(.isDarkTheme) .kichat-time {\n    color: rgba(255, 255, 255, 0.4);\n}\n\n/* ---------- Next-steps suggestion chips ---------- */\n.kichat-nextsteps {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 8px;\n}\n\n.kichat-nextstep {\n    max-width: 100%;\n    text-align: left;\n    padding: 6px 12px;\n    border-radius: 16px;\n    border: 1px solid var(--primary-color, #1976d2);\n    background: var(--background-color, #fff);\n    color: var(--primary-color, #1976d2);\n    font-size: 0.8rem;\n    line-height: 1.3;\n    cursor: pointer;\n    white-space: normal;\n    transition: background 0.15s, color 0.15s;\n}\n\n.kichat-nextstep:hover {\n    background: var(--primary-color, #1976d2);\n    color: var(--primary-contrast, #fff);\n}\n\n:host-context(.isDarkTheme) .kichat-nextstep {\n    background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
